import React, { useState } from "react";
import BriefForm from "./BriefForm"; // הנתיב לפי איפה ששמת את הקומפוננטה של הטופס

export default function FormPage() {


    const [showForm, setShowForm] = useState("BriefForm");
  return (

      <div className="form_page" dir="rtl">

<div className="form-page-in">
<div className="forms-headline">
 <h1 className="mb-s-15"  >טפסים</h1>
 <img src="./for-all-app/kerk_logo.svg" alt="Kerk Logo"  className='form-logo'  />
</div>


        <div className="forms">
      {showForm === "BriefForm" &&  <BriefForm setShowForm={setShowForm}/>}
        </div>


   {showForm === "submitted"  &&
     <div className=" " 
         style={{
      flex: 1,                 // תופס את כל הגובה האפשרי של ההורה
      display: "flex",
      flexDirection: "column",
      justifyContent: "center", // מרכז אנכית
      alignItems: "center",     // מרכז אופקית
 
      width: "100%"             // תופס את כל הרוחב
    }}>
        <h2 className="">הטופס נשלח בהצלחה 😎</h2>
        <p>תודה על מילוי הטופס, נחזור אליך בהקדם.</p>
      </div>
   }



</div>


      </div>

  );
}